module.exports = __webpack_public_path__ + "static/media/whatsapp-link.78100647.svg";